<template>
    <li class="list-group-item d-flex flex-nowrap py-2 px-2">
        <div class="pr-2">
            <div class="btn-group">
                <button class="btn btn-sm btn-light border"
                        v-if="index > 0"
                        v-on:click="moveUp">
                    ⬆️
                </button>
                <button class="btn btn-sm btn-light border"
                        v-if="index < length - 1"
                        v-on:click="moveDown">
                    ⬇️
                </button>
            </div>
        </div>
        <div class="d-flex align-items-center flex-grow-1 pr-2">
            <p class="mb-0"
               v-if="!isInEditMode">
                <color-dot class="mr-1"
                           size="sm"
                           v-bind:color="category.color">
                </color-dot>
                {{ category.name }}
            </p>
            <div class="d-flex flex-nowrap w-100"
                 v-else>
                <b-form-input class="input-color mr-1"
                              size="sm"
                              type="color"
                              v-model="categoryColor">
                </b-form-input>
                <b-form-input class="flex-grow-1"
                              size="sm"
                              type="text"
                              v-model="categoryName">
                </b-form-input>
            </div>
        </div>
        <div>
            <div class="btn-group">
                <button class="btn btn-sm btn-light border"
                        v-if="isInEditMode"
                        v-on:click="edit">
                    💾
                </button>
                <button class="btn btn-sm btn-light border"
                        v-if="isInEditMode"
                        v-on:click="cancel">
                    ❌
                </button>
                <button class="btn btn-sm btn-light border"
                        v-if="!isInEditMode"
                        v-bind:class="{ 'btn-loading': isLoading, }"
                        v-on:click="toggle">
                    <span v-bind:class="{ 'text-line-through': !isActive }">
                        👁️
                    </span>
                </button>
                <button class="btn btn-sm btn-light border"
                        v-if="!isInEditMode"
                        v-bind:class="{ 'btn-loading': isLoading, }"
                        v-on:click="isInEditMode = true">
                    ✏️
                </button>
                <span v-b-tooltip="activities.length > 0 ? `Still used by ${ activities.length } activities` : ''">
                    <button class="btn btn-sm btn-light border border-left-0"
                            style="border-top-left-radius: 0; border-bottom-left-radius: 0; "
                            v-if="!isInEditMode"
                            v-bind:class="{ 'btn-loading': isLoading, }"
                            v-bind:disabled="activities.length > 0"
                            v-on:click="remove">
                    🗑️
                    </button>
                </span>

            </div>
        </div>
    </li>
</template>

<script>
import { BFormInput, VBTooltip, } from "bootstrap-vue";
export default {
    name: "CategoryItem",
    components: {
        BFormInput,
        ColorDot: () => import("../../ColorDot"),
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        category: {
            type: Object,
        },
        index: {
            type: Number,
        },
        categories: {
            type: Array,
        },
    },
    data () {
        return {
            isLoading: false,
            isInEditMode: false,

            categoryNameLocal: "",
            categoryColorLocal: "",
        };
    },
    computed: {
        isActive () {
            return this.category?.isActive ?? true;
        },
        length () {
            return this.categories.length;
        },
        categoryName: {
            get () {
                return this.categoryNameLocal || this.category?.name;
            },
            set (val) {
                this.categoryNameLocal = val;
            }
        },
        categoryColor: {
            get () {
                return this.categoryColorLocal || this.category?.color;
            },
            set (val) {
                this.categoryColorLocal = val;
            }
        },
        activities () {
            return this.$store.getters["event/itemsByCategory"](this.category?._id);
        },
    },
    methods: {
        async moveUp () {
            if (this.index === 0) {
                return;
            }

            const temp = this.categories.slice(0);
            const original = temp[this.index - 1];
            temp[this.index - 1] = temp[this.index]
            temp[this.index] = original;

            try {
                await Promise.allSettled(
                    temp.map(
                        async ({ _id, order }, ind) => {
                            if (order !== ind) {
                                return this.$store.dispatch(
                                    "category/editCategory",
                                    {
                                        _id,
                                        "order": ind
                                    }
                                );
                            }
                            return undefined;
                        }
                    )
                );
            } catch (e) {
                console.error(e);
            }
        },
        async moveDown () {
            if (this.index === this.categories.length - 1) {
                return;
            }

            const temp = this.categories.slice(0);
            const original = temp[this.index + 1];
            temp[this.index + 1] = temp[this.index]
            temp[this.index] = original;

            try {
                await Promise.allSettled(
                    temp.map(
                        async ({ _id, order }, ind) => {
                            if (order !== ind) {
                                return this.$store.dispatch(
                                    "category/editCategory",
                                    {
                                        _id,
                                        "order": ind
                                    }
                                );
                            }
                            return undefined;
                        }
                    )
                );
            } catch (e) {
                console.error(e);
            }
        },
        cancel () {
            this.isInEditMode = false;
            this.categoryNameLocal = "";
            this.categoryColorLocal = "";
        },
        async toggle () {
            this.isLoading = true;
            try {
                await this.$store.dispatch(
                    "category/editCategory",
                    {
                        "_id": this.category._id,
                        "isActive": !this.category?.isActive ?? false,
                    }
                );
                this.isLoading = false;
            } catch (e) {
                console.error(e);
                this.isLoading = false;
            }
        },
        async edit () {
            this.isLoading = true;
            try {
                await this.$store.dispatch(
                    "category/editCategory",
                    {
                        "_id": this.category._id,
                        "name": this.categoryName,
                        "color": this.categoryColor,
                    }
                );
                this.isInEditMode = false;
                this.categoryNameLocal = "";
                this.categoryColorLocal = "";
                this.isLoading = false;
            } catch (e) {
                console.error(e);
                this.isLoading = false;
            }
        },
        async remove () {
            if (this.activities.length > 0) {
                return;
            }
            this.isLoading = true;
            try {
                await this.$store.dispatch(
                    "category/deleteCategory",
                    this.category._id
                );
                this.isLoading = false;
            } catch (e) {
                console.error(e);
                this.isLoading = false;
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.input-color {
    max-width: 70px;
}

.text-line-through {
    text-decoration: line-through;
    text-decoration-thickness: 3px;
}
</style>
